<template>
  <app-layout>
    <dashboard-layout>
      <template slot="header-out">
        <v-flex xs12>
          <v-card>
            <v-toolbar color="primary" dark class="pb-0 mb-0">
              <v-btn icon @click="goBack">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-toolbar-title>{{ $t('Notificación') }}</v-toolbar-title>
            </v-toolbar>
            <v-progress-linear
              v-if="loadingEntity"
              class="py-0 my-0"
              height="3"
              :indeterminate="loadingEntity"
            ></v-progress-linear>
            <v-card>
              <template v-if="!loadingEntity">
                <v-card-title>
                  <div>
                    <h1>{{ $t(entity.title) }}</h1>
                    <br />
                    <div class="grey--text">
                      <v-icon color="grey" size="14">mdi-calendar</v-icon>
                      {{ entity.date | moment('DD/MM/YYYY') }}
                    </div>
                  </div>
                </v-card-title>
                <v-card-text v-html="entity.body"></v-card-text>
              </template>
              <v-card-text v-else></v-card-text>
            </v-card>
          </v-card>
        </v-flex>
      </template>
      <template slot="sidebar">
        <v-flex md12>
          <my-consultant-conversation></my-consultant-conversation>
        </v-flex>
        <v-flex md12 pt-3>
          <calendar-events></calendar-events>
        </v-flex>
      </template>
    </dashboard-layout>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import apiCtrl from '@/services/aru-services/aru-api.service.js';
import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
import MyConsultantConversation from '@/modules/myconsultant/components/threads/MyConsultantConversation.vue';

import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';

export default {
  components: {
    AppLayout,
    DashboardLayout,
    MyConsultantConversation,
    CalendarEvents,
  },
  props: {
    id: {
      type: [String, Number],
    },
  },
  data() {
    return {
      loadingEntity: true,
      entity: null,
    };
  },
  mounted() {
    this.getEntity();
  },
  methods: {
    getEntity() {
      this.loadingEntity = true;
      if (this.id) {
        apiCtrl.get(`/user-broadcast-messages/my-messages/${this.id}`).then(res => {
          this.loadingEntity = false;
          this.entity = res.data.data;
          this.markAsRead(this.id);
        });
      }
    },
    markAsRead(id) {
      setTimeout(() => {
        apiCtrl.put(`/user-broadcast-messages/readed/${id}`, { readed: true }).then(res => {
          console.log('readed:', res);
        });
      }, 2000);
    },
    goBack() {
      this.$router.push({
        path: '/notifications',
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
